
import { COMPARATIVE_TABLE_DATA, LOADER_STATUS, SAVE_TABLE_DATA } from './constants';
// The initial state of the App
export const initialState = {
  loaderStatus: false,
  saveTableData: [],
  comparativeTableData:[],

};
/* eslint-disable default-case, no-param-reassign */
const imsSaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
      case SAVE_TABLE_DATA:
        return{
          ...state,
          saveTableData:action.saveTableData,
        };
        case COMPARATIVE_TABLE_DATA:
          return{
            ...state,
            comparativeTableData:action.comparativeTableData,
          }
      
    default:
      return state;
  }
};

export default imsSaveReducer;